import { Dispatch, useEffect } from 'react';

import {
  OnboardingContextAction,
  OnboardingContextActionType,
  OnboardingPayloadData,
  useOnboardingContext
} from '@/contexts/onboardingContext';
import {
  OnboardingNodeType,
  OnboardingStepType
} from '@/pages/members/pages/Onboarding/steps/types';
import isBeingSubmitted from '@/pages/members/pages/Onboarding/utils/isBeingSubmitted';

/**
 * submission that happens on each step
 */
export const useStepSubmit = <T extends OnboardingPayloadData>({
  dispatch,
  handleSubmit,
  nodeType,
  uid
}: {
  dispatch: Dispatch<OnboardingContextAction>;
  handleSubmit?: (callback: (data: T) => void) => () => void;
  nodeType: OnboardingNodeType;
  uid: OnboardingStepType;
}) => {
  const onboardingContext = useOnboardingContext();

  const onSubmit = (data: T | undefined = undefined) => {
    dispatch({
      type: OnboardingContextActionType.SUBMIT,
      payload: {
        nodeType: nodeType,
        stepName: uid,
        ...(data && { data })
      }
    });
  };

  useEffect(() => {
    if (isBeingSubmitted(nodeType, uid, onboardingContext.steps)) {
      if (!handleSubmit) {
        onSubmit();
      } else {
        // If handleSubmit is provided, we call it to get the submit function
        // This is useful for steps that require a form submission
        handleSubmit(onSubmit)();
      }

      dispatch({
        type: OnboardingContextActionType.CLEAR_SUBMIT,
        payload: {
          node: nodeType,
          uid: uid
        }
      });
    }
  }, [onboardingContext.steps]); // eslint-disable-line react-hooks/exhaustive-deps
};
